import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const BusinessInterior = () => {
  return (
    <SubLayout
      title="실내건축"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_building.jpg"
    >
      <Intro>
        주식회사 두성시스템은 다년간의 풍부한 시공 경험을 바탕으로 감각적인 디자인과 완벽한 시공 품질을 제공합니다.
        공공기관, 사무실, 상업 공간 등 다양한 분야의 실내건축 공사를 전문적으로 수행하고 있습니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🏢</div>
          <h4>사무공간 인테리어</h4>
          <p>업무 효율을 높이는 기능적이고 쾌적한 사무공간을 설계·시공합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🏗️</div>
          <h4>공공기관 시공</h4>
          <p>관공서, 학교, 공공시설 등 다양한 공공기관 실내건축 공사를 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🛒</div>
          <h4>상업공간 시공</h4>
          <p>매장, 식당, 카페 등 브랜드 이미지에 맞는 상업공간을 완성합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🔧</div>
          <h4>리모델링</h4>
          <p>노후화된 공간을 새롭게 탈바꿈시키는 전문 리모델링 서비스를 제공합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>다년간의 시공 경험</h4>
        <p>2008년 창업 이래 100건 이상의 실내건축 공사를 성공적으로 완수한 풍부한 노하우를 보유하고 있습니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>전문 인력 보유</h4>
        <p>자격증을 보유한 전문 기술자가 직접 시공하여 품질과 안전을 보장합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>체계적인 A/S 관리</h4>
        <p>시공 완료 후에도 지속적인 사후 관리 서비스를 통해 고객 만족을 실현합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessInterior;
